import React, {FC, useCallback, useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../helpers'
import {useStatusMessage} from '../../../app/features'
import {FormikHelpers, useFormik} from 'formik'
import {SAVSatisfaction, useSAV} from '../../../app/@types'
import * as Yup from "yup"
import {Ratings} from '../../../app/@components'
import {TextArea} from '../content/forms'
import {UserInterface} from '../../../app/modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {Post, RootState} from '../../../setup'
import {useParams} from 'react-router-dom'

const SEND_SATISFACTION = process.env.REACT_APP_SAV_TICKETS_SATISFACTION_TICKET || 'sav/satisfaction'

const Schema = Yup.object({
  rating: Yup.string().required('Rating is required'),
  comments: Yup.string(),
})

const initialValues = {
  rating: '',
  comments: '',
}

type Props = {
  satisfaction: SAVSatisfaction | null;
  status: string | null
}


const SatisfactionSav: FC<Props> = ({satisfaction, status}) => {

  const {id: userId}: UserInterface = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserInterface
  let {id: ticketId}: {id: string} = useParams()
  const {triggerReload} = useSAV()

  const modalRef = useRef<HTMLDivElement | null>(null)
  const closeRef = useRef<HTMLButtonElement | null>(null)
  const openRef = useRef<HTMLButtonElement | null>(null)
  const [showModal, setShowModal] = useState<boolean>(false)

  const {formState, setLoading} = useStatusMessage()

  const onSubmit = async (values: typeof initialValues, {
    setSubmitting,
    resetForm,
  }: FormikHelpers<typeof initialValues>) => {

    setLoading(true)
    setSubmitting(false)

    const formData = new FormData()
    formData.append('client_id', `${userId}`)
    formData.append('sav_ticket_id', ticketId)
    formData.append('rating', values.rating)
    formData.append('comments', values.comments)

    try {
      const {status} = await Post<{status: number}>(SEND_SATISFACTION, formData)
      if (status === 200) {

        handleModalClose()
        setShowModal(true)
        triggerReload()
        resetForm()
      }
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
      setSubmitting(false)
    }

  }

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    enableReinitialize: true,
    onSubmit,
  })

  const handleModalOpen = useCallback(
    () => {
      if (openRef.current) openRef.current?.click()
    },
    [],
  )

  const handleModalClose = useCallback(
    () => {
      if (modalRef.current) modalRef.current?.click()
    },
    [],
  )

  useEffect(() => {

      setTimeout(() => {
        if (satisfaction === null && status === 'Fermé' && !showModal) handleModalOpen()
      }, 1000)
    },
    [handleModalOpen, showModal, satisfaction, status])

  return (
    <>
      <div className="text-center">
        <button type="button"
                className="d-none"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_satisfaction_ticket"
                ref={openRef}
        >
          <KTSVG path="/media/icons/duotune/general/gen035.svg" className="svg-icon-2 me-2" />
          open modal
        </button>
      </div>
      <div className="modal fade" id={'kt_modal_satisfaction_ticket'} aria-hidden="true" ref={modalRef}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-header">
                <h5>Satisfaction</h5>
                <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                  <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
                </div>
              </div>
              <div className="modal-body p-3 p-sm-5  p-md-7">

                <Ratings ratingsLength={5} ratingSize={'fs-1'} formik={formik} fieldName={'rating'} />

                <TextArea cols={10} rows={5} flex={"column"} formik={formik} name={"comments"} label={"Commentaires"} />

                {/*<Status {...formState.statusMessage} />*/}
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-sm btn-primary me-2 px-6"
                        disabled={formik.isSubmitting || !formik.isValid || formState.loading}
                >
                  {formState.loading ? (
                    <span className="indicator-progress d-block">
                    S'il vous plaît, attendez... <span className="spinner-border spinner-border-sm align-middle ms-2" />
                  </span>
                  ) : (
                    'Sauvegarder'
                  )}
                </button>
                <button type="button"
                        className="btn btn-sm btn-light me-2 px-6"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          handleModalClose()
                          formik.resetForm()
                        }}
                        ref={closeRef}
                >
                  Fermer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export {SatisfactionSav}